import { isNonEmptyString } from '../utilities';

type Params = {
  afterPasswordResetRedirectUrl?: string | null;
};
export class RedirectionAfterPasswordReset {
  private afterPasswordResetRedirectUrl: string | null;
  constructor({ afterPasswordResetRedirectUrl }: Params) {
    this.afterPasswordResetRedirectUrl = afterPasswordResetRedirectUrl ?? null;
  }

  canRedirect(): boolean {
    const canRedirect = isNonEmptyString(this.afterPasswordResetRedirectUrl);
    return canRedirect;
  }
  getRedirectUrl(): string {
    if (!this.canRedirect()) {
      throw Error('getting redirect user url has performed without checking precondition');
    }
    return this.afterPasswordResetRedirectUrl ?? '/';
  }

  static isPathInWhiteList(pathname: string): boolean {
    const marketingFlowCreateAccountRegExp = /^\/?(es\/)?create-account\/.+\/?/i;
    return marketingFlowCreateAccountRegExp.test(pathname);
  }
}
